/**
 * Cookie de idioma compartida con sporttia-competitions, que la escribe con
 * `next-intl` bajo el nombre `locale` y en la raíz del sitio. Las dos
 * aplicaciones se sirven desde el mismo dominio (premanager/manager), así que
 * basta con leer y escribir la misma cookie para que el idioma no cambie al
 * pasar de una a otra.
 */
const COOKIE_NAME = 'locale';
/** Un año, como cualquier preferencia de interfaz. */
const MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

export function readLocaleCookie(): string | null {
    const match = document.cookie.match(
        new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`),
    );

    return match?.[1] ? decodeURIComponent(match[1]) : null;
}

export function writeLocaleCookie(locale: string): void {
    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(locale)}; path=/; max-age=${MAX_AGE_SECONDS}; samesite=lax`;
}
